<template>
    <div>
        <el-card class="box-card">
            <div slot="header" style="display:flex;justify-content: space-between;">
                <span class="top_title">商品列表</span>
                <div>
                    <el-input
                        type="text"
                        size="mini"
                        style="width:200px"
                        v-model="productInfo"
                        @change="searchTime()"
                        placeholder="输入商品名称或编号">
                        <i slot="suffix" class="el-input__icon el-icon-search" style="color:#1f8fff" @click="searchTime()"></i>
                    </el-input>
                </div>
            </div>
            <div class="searchItem">
                <div v-if="GLOBAL.userType==0">
                    <Customer ref="ccc" :createAlllow="true" :orderForm="orderForm" @change="selectCustomerBySelect" :tips='true'></Customer>
                </div>
                <div class="search" v-if="$global.useinstall==1&&orderForm.cid>0">
                    <span class="searchtips">货运方式:</span>
                    <el-select v-model="orderForm.method" style="width:180px">
                        <el-option value="自提" label="自提"></el-option>
                        <el-option value="车辆运送" label="车辆运送"></el-option>
                        <el-option value="物流" label="物流"></el-option>
                    </el-select>
                </div>
                <div class="search" v-if="$global.useinstall!=1">
                    <span class="searchtips">标签:</span>
                    <el-select
                        v-model="label"
                        multiple collapse-tags
                        @visible-change="visibleChange"
                        @remove-tag="removeTag"
                        style="width:160px"
                    >
                        <el-option
                            v-for="(ele,index) in labelList"
                            :key="index"
                            :label="ele"
                            :value="ele"
                        >
                        </el-option>
                    </el-select>
                </div>
                <div class="search">
                    <span class="searchtips">商品分类:</span>
                    <el-switch
                        @change="showTypeChange"
                        v-model="showType"
                        size='mini'
                        :active-value="true"
                        :inactive-value="false"
                    />
                </div>
                <div class="search" style="cursor: pointer;margin-top:4px">
                    <i
                        class="iconfont"
                        style="font-size: 28px;margin-left: 10px;color: #737980;"
                        @click="changeShowTable()"
                        v-html="GLOBAL.showTable ? '&#xe613;' : '&#xe82f;'"
                    ></i>
                </div>
            </div>
            <div v-if="orderForm.cid>0&&$global.useinstall==1" style="display:flex">
                <span class="searchtips">安装地址</span>
                <el-input maxlength="200" style="width:480px" placeholder="安装详细地址" v-model="orderForm.address"></el-input>
            </div>
            <div v-if="orderForm.cid>0">
                <Address ref='paddr' @setContact='setContact' :cid='orderForm.cid' :contact='orderForm.contact'></Address>
            </div>
            <div class="box" v-loading="loading">
                <div class="leftType" v-show="showType">
                    <classify
                        :classifyData="classifyData"
                        @handleClassifyChange="handleClassifyChange"
                    ></classify>
                </div>
                <div class="rightType" :class="showType ? '' : 'widthbai'">
                    <goods
                        :goods="goods"
                        :currentPage="currentNumber"
                        :sizeNumber="sizeNumber"
                        :totalNumber="totalNumber"
                        @handleSizeChange="handleSizeChange"
                        @handleCurrentChange="handleCurrentChange"
                        v-show="!GLOBAL.showTable"
                        @openDialog="openDialog"
                        @updateNum="updateNum2"
                    ></goods>
                    <goodstable
                        ref="gts"
                        :goods="goods"
                        :currentPage="currentNumber"
                        :sizeNumber="sizeNumber"
                        :totalNumber="totalNumber"
                        @handleSizeChange="handleSizeChange"
                        @handleCurrentChange="handleCurrentChange"
                        v-show="GLOBAL.showTable"
                        @updateNum="updateNum2"
                    ></goodstable>
                </div>
            </div>
            <div v-if="orderForm.cid>0">
                <div class="searchItem">
                    <div class="search">
                        <Invoice :orderForm="orderForm"></Invoice>
                    </div>
                    <div class="search">
                        <span class="searchtips">结算账号:</span>
                        <el-select v-model="orderForm.accountid" style="width:200px">
                            <el-option
                                v-for="item in actList"
                                :key="item.id"
                                :label="item.name+'('+item.account+')'"
                                :value="item.id"
                            ></el-option>
                        </el-select>
                    </div>
                </div>
            </div>
        </el-card>
        <el-form class="root_Panel">
            <div class="root_box">
                <div class="searchItem" v-if="GLOBAL.userType==0">
                    <div class="search" style="margin-bottom: 5px;">
                        <span class="searchtips">免除(元):</span>
                        <el-input
                            v-model="orderForm.free"
                            type="number"
                            :min="0"
                            @input="$common.checkMoney($event,orderForm,'free')"
                            style="width: 120px"
                        ></el-input>
                    </div>
                    <div class="search" style="margin-bottom: 5px;">
                        <span class="searchtips">付款(元):</span>
                        <el-input
                            v-model="orderForm.pay"
                            type="number"
                            :min="0"
                            @input="$common.checkMoney($event,orderForm,'pay')"
                            style="width: 120px"
                        ></el-input>
                    </div>
                </div>
                <div style="display:flex;justify-content: space-between;">
                    <div style="padding-right:10px">
                        <span class="root_count span_num">{{ maxCount }}</span>
                        <span class="root_cost span_num" v-if="GLOBAL.showProductPrice">{{ maxCost }}</span>
                    </div>
                    <div>
                        <el-button type="primary" @click="goToPage()"
                            >购物车</el-button
                        >
                        <el-button type="warning"  @click="checkCustomer(true)" v-show="$common.hasLimits('addOrder')"
                            >立即下单</el-button
                        >
                    </div>
                </div>
            </div>
        </el-form>
        <el-dialog :title="titlename" :visible.sync="moreBuyDialog" width="60%">
            <Scope
                :tableData="dialogInfo"
                :packing="packing"
                @addMore="checkCustomer"
                @updateNum="updateNum"
                @close='close'
            ></Scope>
        </el-dialog>
        <ReportOrder ref="roder" style="margin-top:80px" :printCol="selectCols"></ReportOrder>
    </div>
</template>

<script>
import classify from "@/components/classify.vue";
import goods from "@/components/goods.vue";
import goodstable from "@/components/goodsTable.vue";
import Scope from "@/components/scope.vue";
import Invoice from "@/components/invoice.vue"
import Customer from '@/components/customer.vue';
import ReportOrder from '../../components/printshare/reportorder';
import Address from "../../components/place/index.vue";
export default {
    components: {
        classify,
        goods,
        goodstable,
        Scope,
        Invoice,
        Customer,
        ReportOrder,
        Address,
    },
    data() {
        return {
            loading: false,
            checked: false,
            showType: false,
            GLOBAL: this.$global,
            addOrderId:0,
            labelList:[],
            goods: [],
            sort: {
                prop: "",
                name: "默认排序",
                mode: "desc",
            },
            sortObj:{
                column:'',
                desc:'',
            },
            // sortList:[
            //     {label:'商品编号',value:"number"},
            //     {label:'商品名称',value:"name"},
            //     {label:'商品价格',value:"price"},
            //     {label:'商品日期',value:"date"},
            // ],
            actList:[],
            classifyData: [],
            value: "",
            sizeNumber: 20,
            currentNumber: 1,
            totalNumber: 100,
            label: [],
            classify: -1,
            productInfo: "",

            maxCount: 0,
            maxCost: 0,
            maxSum: 0,

            orderList: [],
            titlename: "",
            packing:"件",
            selectID: -1,
            dialogInfo: [],
            moreBuyDialog: false,
            orderForm: {
                cid: -1,
                contact: "",
                contactValue: "",
                number: "",
                emp: "",
                empname: "",
                cname: " ",
                invoicetype: "0",
                invoice: "",
                invoiceaddress: "",
                invoicephone: "",
                bankname: "",
                bankaccountnumber: "",
                taxidentification: "",
                payed: 0,
                state: 0,
                accountid: "0",
                accountname: "",
                date: this.$common.format(new Date()),
                detail: [],
                pay: 0,
                free: 0,
                remark: "",
                pri: "",
                address:'',
                method:'',
            },
            tempItemList:[],
            selectCols:'',
        };
    },
    created() {
        this.getClassify();
        this.initShopingcart();
        if (this.GLOBAL.userType == 1) {
            this.orderForm.cid = parseInt(this.GLOBAL.id);
            let data={id:this.GLOBAL.id};
            this.$api.getInfoPostSingle("/mobile/customer/customerDetail",data).then(res=>{
                this.setCustomer(res);
            })
        } else if (this.GLOBAL.userType == 0) {
            if(this.GLOBAL.cid>0){
                this.orderForm.cid = parseInt(this.GLOBAL.cid);
                this.selectCustomerBySelect(this.GLOBAL.cid);
            }else{
                this.currentNumber = 1;
                this.getData();
            }
        };
        this.getCompanyAccount();
        let temp = localStorage.getItem("orderCols");
        if(temp){
            let arr = JSON.parse(temp);
            if(arr&&arr.length>0){
                this.selectCols=arr.join(',');
            }
        }
    },
    methods: {
        setContact(id){
            this.orderForm.contact = id;
        },
        close(){
            this.moreBuyDialog = false;
        },
        showTypeChange(e){
            if(!e&&this.classify > 0){
                this.classify = 0;
                this.currentNumber = 1;
                this.getData();
            }
        },
        saveInvoice() {
        },
        goToPage() {
            this.$router.push("/car");
        },
        initShopingcart() {
            let sp = JSON.parse(localStorage.getItem("shopingcart"));
            if (!sp) {
                return;
            }
            this.orderList = sp;
            let list = this.getProductList();
            this.getItemlist(list);
        },
        getProductList(){
            let productList = [];
            for(let i in this.orderList){
                let id = this.orderList[i].id;
                if(productList.indexOf(id)==-1){
                    productList.push(id);
                }
            }
            return productList;
        },
		getItemlist:function(list){
			if(list.length>0){
				let arr = [];
				list.forEach(e=>{
					let obj = {
						str:"/mobile/product/productDetail",
						data:{id:e},
						func:(res)=>{
                            this.tempItemList.push(res.data.data);
                        }
					}
					arr.push(obj);
				})
				this.$api.getInfoByPost(arr,()=>{
					this.updateItemList();
				})
			}
		},
        //更新数据
        updateItemList(){
            let temp = [];
            this.orderList.forEach(e=>{
                let item = this.updateItem(this.tempItemList,e);
                if(item!=null){
                    temp.push(item);
                }
            })
            this.orderList = temp;
            this.tempItemList = [];
            this.$global.shoppingCartNumber = this.orderList.length;
            localStorage.setItem("shopingcart", JSON.stringify(this.orderList));
            this.updateCount();
        },
        updateItem(itemList,e){
            let id = e.id;
            let hasone = false;
            for(let i in itemList){
                let target = itemList[i];
                if(target.id==id){
                    e.imgpath=[];
                    
                    target.img.forEach(s=>{
                        let str = this.$api.baseURL+s;
                        e.imgpath.push(str);
                    })
                    e.number=target.number;
                    e.name=target.name;
                    e.packing=target.packing;
                    for(let j in target.specs){
                        let spec = target.specs[j];
                        if(spec.id==e.spid){
                            e.color=spec.color;
                            e.size=spec.size;
                            e.unit=spec.unit;
                            hasone = true;
                            break;
                        }
                    }
                    break;
                }
            }
            if(hasone){
                return e;
            }else{
                return null;
            }
        },
        getOrderOne(id, spid) {
            for (let i = 0; i < this.orderList.length; i++) {
                let obj = this.orderList[i];
                if (obj.id == id && obj.spid == spid) {
                    return obj;
                }
            }
            return null;
        },
        updateNum2(target, spid) {
            let selectid = target.id;
            let err = false;
            let index = 0;
            for (let i = 0; i < target.specs.length; i++) {
                let sp = target.specs[i];
                if (sp.id == spid) {
                    index = i;
                    if(sp.count==0&&sp.num==0){
                        err = true;
                    }
                    break;
                }
            }
            let olindex = -1;
            for (let i = 0; i < this.orderList.length; i++) {
                let obj = this.orderList[i];
                if (obj.id == selectid && obj.spid == spid) {
                    olindex = i;
                    break;
                }
            }
            if(err){
                if(olindex>=0){
                    this.orderList.splice(olindex,1);
                    this.updateCount();
                    localStorage.setItem("shopingcart", JSON.stringify(this.orderList));
                    this.GLOBAL.shoppingCartNumber = this.orderList.length;
                }
                return;
            }
            
            let np = target.specs[index].price?target.specs[index].price:0;
            if (olindex == -1) {
                let obj = {
                    id: selectid,
                    spid: spid,
                    imgpath: target.img,
                    number: target.number,
                    name: target.name,
                    color: target.specs[index].color,
                    size: target.specs[index].size,
                    packing: target.packing,
                    price: np>0?np:0,
                    money: target.specs[index].retail,
                    count: target.specs[index].count?target.specs[index].count:0,
                    num:target.specs[index].num?target.specs[index].num:0,
                    unit: target.specs[index].unit,
                };
                this.orderList.unshift(obj);
            } else {
                let obj = this.orderList.splice(olindex,1)[0];
                obj.count=target.specs[index].count?target.specs[index].count:0;
                obj.num=target.specs[index].num?target.specs[index].num:0;
                obj.price=np?np:0;
                this.orderList.unshift(obj);
            }
            this.updateCount();
            localStorage.setItem("shopingcart", JSON.stringify(this.orderList));
            this.GLOBAL.shoppingCartNumber = this.orderList.length;
        },
        updateCount() {
            let count = 0;
            let cost = 0;
            let sum = 0;
            this.orderList.forEach((e) => {
                let cnumber = parseInt(e.num);
                if (!cnumber) {
                    cnumber = 0;
                }
                let ccount = parseInt(e.count);
                if(!ccount){
                    ccount = 0;
                }
                let unit = parseInt(e.unit);
                if(!unit){
                    unit = 0;
                }
                let cprice = parseFloat(e.price);
                if (!cprice) {
                    cprice = 0;
                }
                if (cnumber > 0 || ccount>0) {
                    count++;
                    cost += cnumber*cprice+ccount*unit*cprice;
                    sum += cnumber+ccount*unit;
                }
            });
            this.maxCount = count;
            this.maxCost = cost.toFixed(2);
            this.maxSum = sum;
        },
        updateNum(spid) {
            for (let i = 0; i < this.goods.length; i++) {
                let item = this.goods[i];
                if (item.id == this.selectID) {
                    this.updateNum2(item, spid);
                    break;
                }
            }
        },
        openDialog(id) {
            this.selectID = id;
            let nowgoods = this.orderList[id];
            if (nowgoods == null) {
                nowgoods = {};
            }
            for (let i = 0; i < this.goods.length; i++) {
                let item = this.goods[i];
                if (item.id == id) {
                    item.specs.forEach((e) => {
                        let ncount = 0;
                        let nnumber = 0;
                        let nowgoods = this.getOrderOne(id, e.id);
                        if (nowgoods != null) {
                            if (nowgoods.count > 0) {
                                ncount = nowgoods.count;
                            }
                            if(nowgoods.num > 0) {
                                nnumber = nowgoods.num;
                            }
                        }
                        e.num = nnumber;
                        e.count = ncount;
                    });
                    this.dialogInfo = item.specs;
                    this.titlename = item.name;
                    this.moreBuyDialog = true;
                    this.packing = item.packing;
                    break;
                }
            }
        },
        handleClassifyChange(val) {
            if (this.classify == val) {
                return;
            }
            this.classify = val;
            this.currentNumber = 1;
            this.getData();
        },
        handleSizeChange(val) {
            if (this.sizeNumber == val) {
                return;
            }
            this.sizeNumber = val;
            this.getData();
        },
        searchTime(){
            this.currentNumber = 1;
            this.getData();
        },
        handleCurrentChange(val) {
            if (this.currentNumber == val) {
                return;
            }
            this.currentNumber = val;
            this.getData();
        },

        //获取商品列表
        getData() {
            this.loading = true;
            let ob = {
                page: this.currentNumber,
                limit: this.sizeNumber,
                valid: 1,
                cid:this.orderForm.cid,
            };
            if (this.label.length>0) {
                ob.label = this.label.join(",");
            }
            if (this.sortObj.column) {
                ob.column = this.sortObj.column;
                ob.order = this.sortObj.order?'asc':'desc';
            }
            if (this.classify > 0 && this.showType) {
                ob.category = this.classify;
            }
            if (this.productInfo != null && this.productInfo != "") {
                ob.product = this.productInfo;
            }
            this.$api.productlistProduct(ob).then((res) => {
                let data = res.data;
                this.goods = [];
                if (data.code == 1) {
                    this.totalNumber = data.count;
                    data.data.forEach((e) => {
                        let temp = e.img;
                        e.img = [];
                        if(temp.length>0){
                            temp.forEach((s) => {
                                if (s) {
                                    e.img.push(this.$api.baseURL + s);
                                } else {
                                    e.img.push("");
                                }
                            });
                        }else{
                            e.img.push("");
                        }
                        let color = [];
                        let size = [];
                        let oldArr = this.GLOBAL.goodsSelect[e.id];
                        let newArr = [];
                        if(!e.minstock){
                            e.minstock = 0;
                        }
                        if(!oldArr){
                            oldArr = [];
                        }
                        let index = 0;
                        let totalStock = 0;
                        let totalAmount = 0;
                        let totalParts = 0;
                        e.specs.forEach((s) => {
                            if(oldArr.indexOf(s.id)>=0){
                                newArr.push(index);
                                s.show = true;
                            }else{
                                s.show = false;
                            }
                            index++;
                            
                            let nocolor = true;
                            let scinfo = this.getOrderOne(e.id, s.id);
                            if(scinfo){
                                this.$set(s,'count', scinfo.count?scinfo.count:0);
                                this.$set(s,'num', scinfo.num?scinfo.num:0);
                                s.price = scinfo.price?scinfo.price:0;
                            }else{
                                this.$set(s,'count', 0);
                                this.$set(s,'num', 0); 
                            }
                            color.forEach((m) => {
                                if (m == s.color) {
                                    nocolor = false;
                                }
                            });
                            if (nocolor) {
                                color.push(s.color);
                            }
                            let nosize = true;
                            size.forEach((m) => {
                                if (m == s.size) {
                                    nosize = false;
                                }
                            });
                            if (nosize) {
                                size.push(s.size);
                            }
                            let stock = s.stock-s.needStockOutUnit;
                            let ta = stock>0?Math.floor(stock/s.unit):Math.ceil(stock/s.unit);
                            let tp = stock%s.unit;
                            s.stockDesc = this.$common.changeNumDesc(s,"stockAmount","stockParts","stock");
                            s.stockNSDesc = this.$common.changeNumDesc(s,"needStockOutAmount","needStockOutParts","needStockOutUnit");
                            if(this.$global.buyType==0){
                                s.stockCUDesc = ta+this.$global.pack;
                                if(totalParts!=0){
                                    s.stockCUDesc += tp+this.$global.unit;
                                }
                            }else if(this.$global.buyType==1){
                                s.stockCUDesc = ta+this.$global.pack;
                            }else if(this.$global.buyType==2){
                                s.stockCUDesc = stock+this.$global.unit;
                            }
                            totalStock +=stock;
                            totalAmount += ta;
                            totalParts += tp;
                        });
                        this.$set(e,"sizeValue",newArr);
                        e.color = color;
                        e.size = size;
                        e.stockDesc = this.$common.changeNumDesc(e,"stockAmount","stockParts","stock");
                        e.stockNSDesc = this.$common.changeNumDesc(e,"needStockOutAmount","needStockOutParts","needStockOutUnit");
                        if(this.$global.buyType==0){
                            e.stockCUDesc = totalAmount+this.$global.pack;
                            if(totalParts!=0){
                                e.stockCUDesc += totalParts+this.$global.unit;
                            }
                        }else if(this.$global.buyType==1){
                            e.stockCUDesc = totalAmount+this.$global.pack;
                        }else if(this.$global.buyType==2){
                            e.stockCUDesc = totalStock+this.$global.unit;
                        }
                    });
                    this.goods = data.data;
                    this.updateCount();
                    this.checkTable();
                }
                this.loading = false;
            });
        },
        changeShowTable() {
            this.GLOBAL.showTable = !this.GLOBAL.showTable;
            this.checkTable();
        },
        checkTable(){
            if(this.GLOBAL.showTable){
                this.$nextTick(()=>{
                    this.$refs.gts.updateSpecShow();
                })
            }
        },
        getClassify() {
            this.$api.getGeneralSetting().then((res)=>{
                let label = res.data.data.label;
                this.labelList = label;
            });
            this.$api.productgetProdClassify().then((res) => {
                let arr = [{
                    children:res.data.data,
                    id:-1,
                    label:"全部",
                    level:0,
                    pid:-1,
                }]
                this.classifyData = arr;
            });
        },
        visibleChange(e) {
            if(!e){
                this.currentNumber = 1;
                this.getData();
            }
        },
        removeTag(e){
            this.currentNumber = 1;
            this.getData();
        },
        toFavorites() {
            this.$router.push("/favorites");
        },

        selectCustomerBySelect(id){
            let data={id:id};
            this.$api.getInfoPostSingle("/mobile/customer/customerDetail",data).then(res=>{
                this.setCustomer(res);
            }).catch(
                res=>{
                    this.GLOBAL.cid = 0;
                }
            )
        },
        setCustomer(res) {
            let dt = res.data.data;
            this.orderForm.invoice = dt.invoice;
            this.orderForm.cid = dt.id;
            this.orderForm.cname = dt.cname;
            this.orderForm.taxidentification = dt.taxIdentification;
            this.orderForm.invoiceaddress = dt.invoiceaddress;
            this.orderForm.invoicephone = dt.invoicephone;
            this.orderForm.bankname = dt.bankname;
            this.orderForm.bankaccountnumber = dt.bankaccountnumber;
            if(dt.contact&&dt.contact.length>0){
                let item = dt.contact[0];
                this.orderForm.contact = item.id;
            }
            this.$refs.paddr.init();
            this.currentNumber = 1;
            this.getData();
        },
        checkCustomer(buyall){
            if (!this.$common.checkLimits("addOrder")) {
                return;
            }
            if (this.orderList.length == 0) {
                this.$common.error("没有选择任何商品");
                return;
            }
            if (!buyall) {
                let empty = true;
                this.dialogInfo.forEach((e) => {
                    if (e.num > 0) {
                        empty = false;
                    }
                    if( e.count > 0 ){
                        empty = false;
                    }
                });
                if (empty) {
                    this.$common.error("没有选择任何商品");
                    return;
                }
            }
            if(this.$global.useinstall==1){
                if(!this.orderForm.method){
                    this.$common.error("没有选择货运方式");
                    return;
                }
                if(!this.orderForm.address){
                    this.$common.error("没有填写详细地址");
                    return;
                }
            }
            if(this.orderForm.cid>0){
                this.addMore(buyall);
            }else if(this.orderForm.cid===0){
                this.$nextTick(()=>{
                    this.$refs.ccc.addCustomer((res)=>{
                        this.addMore(buyall);
                    });
                })
            }else{
                this.$common.error("没有选择客户");
            }
        },
        getCompanyAccount(){
            this.$api.companygetCompanyAccount().then(res=>{
                if(res.data.code==1){
                    this.actList = res.data.data;
                    let index = 0;
                    for(let i in this.actList){
                        if(this.actList[i].isdefault==1){
                            index = i;
                            break;
                        }
                    }
                    if(this.actList.length>0){
                        this.orderForm.accountid = this.actList[index].id;
                    }
                }
            })
        },
        addMore(buyall) {
            let arr = [{
                str:'/mobile/order/getOnumber',
                func:(res)=>{
                    this.orderForm.number = res.data.data;
                }
            }]
            if(this.GLOBAL.userType==0){
                arr.push({
                    str:'/mobile/login/getLoginUser',
                    func:(res)=>{
                        this.orderForm.emp = this.GLOBAL.id;
                        this.orderForm.empname = res.data.data.name;
                    }
                })
            }
            this.$api.getInfoByPost(arr,() => {
                this.$confirm("警告", {
                    title: "警告",
                    message: "确认下单?",
                    showCancelButton: true,
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                }).then(
                    () => {
                        if (buyall) {
                            this.loading = true;
                        }
                        this.orderForm.detail = [];
                        let index = 1;
                        this.orderList.forEach((e) => {
                            if (buyall || e.id == this.selectID) {
                                let cc = e.count?e.count:0;
                                let mm = e.num?e.num:0;
                                let obj = {
                                    count: cc,
                                    unitCount: e.unit,
                                    id: index,
                                    image: e.imgpath,
                                    name:e.number +" " +e.name +"_" + e.color +"_" +e.size,
                                    pid: e.id,
                                    price: e.price,
                                    remark: "",
                                    small: mm,
                                    spid: e.spid,
                                    sum: e.price*(cc*e.unit+mm),
                                    unit: cc*e.unit+mm,
                                };
                                this.orderForm.detail.push(obj);
                                index++;
                            }
                        });
                        this.orderForm.detail = JSON.stringify(
                            this.orderForm.detail
                        );
                        this.$api.orderaddOrder(this.orderForm).then((res) => {
                            this.$notify({
                                title: "新增订货单",
                                message: "添加成功",
                                type: "success",
                                duration: 1000,
                                onClose: () => {
                                    let temp = [];
                                    this.loading = false;
                                    this.orderList.forEach((e) => {
                                        if (!buyall) {
                                            if (e.id != this.selectID) {
                                                temp.push(e);
                                            }
                                        }
                                    });
                                    this.orderList = temp;
                                    this.GLOBAL.shoppingCartNumber =
                                        this.orderList.length;
                                    this.updateCount();
                                    this.GLOBAL.goodsSelect = {}
                                    localStorage.setItem(
                                        "shopingcart",
                                        JSON.stringify(this.orderList)
                                    );
                                    if(res.data.code==1){
                                        let arr = [];
                                        arr.push(res.data.data);
                                        this.$refs.roder.extraCheckOpen(0,arr,()=>{
                                            if(this.$common.hasLimits("order")){
                                                this.$router.push({
                                                path: "/order",
                                                query:{type:1},
                                            });
                                            }else{
                                                this.$router.push("/product");
                                            }
                                        });
                                    }
                                },
                            });
                        });
                    },
                    () => {}
                );
            });
        },
    },
};
</script>

<style lang='scss' scoped>
.box-card {
    .box {
        display: flex;
        justify-content: space-between;
        margin-top: 20px;
        .leftType {
            width: 15%;
            margin-right: 1%;
        }

        .rightType {
            width: 84%;
            margin-bottom: 10px;
        }

        .widthbai {
            width: 100% !important;
        }
    }
}
@media (orientation: portrait) {
    .root_Panel {
        height: 120px;
        position: fixed;
        bottom: 0;
        right: 5px;
        left: 85px;
        padding: 20px 20px 15px 20px;
        border: 1px solid #eeeeee;
        box-sizing: border-box;
        background: #fff;
        border-top-left-radius: 15px;
        border-top-right-radius: 15px;
        z-index: 99;
    }
    .root_box {
        width: 100%;
        height: 30px;
        padding-bottom: 20px;
    }
}
@media (orientation: landscape) {
    .root_Panel {
        height: 80px;
        position: fixed;
        bottom: 0;
        right: 5px;
        left: 85px;
        padding: 20px 20px 15px 20px;
        border: 1px solid #eeeeee;
        box-sizing: border-box;
        background: #fff;
        border-top-left-radius: 15px;
        border-top-right-radius: 15px;
        z-index: 99;
    }
    .root_box {
        display: flex;
        justify-content: space-between;
        width: 100%;
        height: 30px;
        padding-bottom: 20px;
    }
}
.span_num {
    height: 40px;
    line-height: 40px;
    color: #ff0000;
    font-size: 14px;
}
.root_count::before {
    content: "已选";
    color: #333;
}
.root_count::after {
    content: "种商品 ";
    color: #333;
}
.root_cost::before {
    content: "合计";
    color: #333;
}
.root_cost::after {
    content: "元";
    color: #333;
}
</style>
